module.exports = __webpack_public_path__ + "img/payment-methods-en.88a61146.png";